<div class="fx-column">
    <span class="label" *ngIf="labelOutside">{{label}}</span>
    <div class="button" [class.active]="selection !== undefined" style="max-width:100%;"
        [cdkMenuTriggerFor]="disabled ? null : menu" #trigger="cdkMenuTriggerFor" [class.disabled]="disabled"
        (cdkMenuOpened)="populate()">
        <div class="fx-row fx-flex-100 align-items-center justify-content-between label-container">
            <span class="text main left fx-flex" *ngIf="selection">{{selection}}</span>
            <div class="text left fx-flex" *ngIf="!selection">{{label}}</div>
            <mat-icon class="dark ml-5" fontSet="material-icons-outlined" *ngIf="!selection">expand_more</mat-icon>
            <mat-icon class="main ml-5" fontSet="material-icons-outlined" *ngIf="selection"
                (click)="$event.stopPropagation();onClear()">clear</mat-icon>
        </div>

    </div>
    <ng-template #menu>
        <mat-card class="menu-container p-0 elevation"
            [class.large]="(trademarks && trademarks.length > 0) || (niceClassification && niceClassification.length > 0)"
            cdkMenu>
            <div class="fx-column" (click)="$event.stopPropagation()">
                <div>
                    <div class="p-16">
                        <div class="fx-row align-items-center justify-content-between mb-5 ">
                            <div class="fx-column fx-flex ellipsis-container" *ngIf="label">
                                <span class="text bold ellipsis">{{label | translate}}</span>
                            </div>
                            <span class="small clickable" (click)="onClear()" *ngIf="multiple">{{'ACTIONS.CLEAR' |
                                translate}}</span>
                        </div>
                        <div class="mb-5">
                            <span class="smaller light">{{'TRADEMARK.PS_DISPLAYED_ORIGINAL_LANG'
                                | translate}}</span>
                        </div>

                        <app-input placeholder="{{'ACTIONS.SEARCH' | translate}}..." type="text" prefix="search"
                            class="mt-10" *ngIf="search" [(value)]="query" (change)="onQueryChange($event)"
                            [autoFocus]="true"></app-input>
                    </div>

                    <mat-divider
                        *ngIf="(trademarks && trademarks.length > 0) || (niceClassification && niceClassification.length > 0)"></mat-divider>
                    <div class="p-16"
                        *ngIf="(trademarks && trademarks.length > 0) || (niceClassification && niceClassification.length > 0)">
                        <div class="fx-row fx-wrap align-items-center justify-content-start "
                            [class.mb-8]="niceClassification && niceClassification.length > 0"
                            *ngIf="trademarks && trademarks.length > 0">
                            <span class="small bold dark fx-flex-100 mb-8">{{'ENTITIES.TRADEMARKS' | translate}}</span>
                            <div class="fx-row align-items-center justify-content-start" style="overflow-x: scroll;">
                                <div class="chip main mr-5 mb-5 fx-row align-items-center justify-content-start"
                                    *ngFor="let trademark of trademarks; let index = index" style="flex-shrink: 0">
                                    <span style="flex-shrink: 0">{{trademark.name || trademark.identifierNumber}}
                                        ({{trademark.countryOfDesignation}})</span>
                                    <mat-icon inline inset class="ml-5 clickable" fontSet="material-icons-outlined"
                                        (click)="removeTrademark(index)" *ngIf="editTmNice">cancel</mat-icon>
                                </div>
                            </div>
                        </div>

                        <div class="fx-row fx-wrap align-items-center justify-content-start"
                            *ngIf="niceClassification && niceClassification.length > 0">
                            <span class="small bold dark fx-flex-100 mb-8">{{'ENTITIES.NICE_CLASSIFICATION' |
                                translate}}</span>
                            <div class="fx-row align-items-center justify-content-start" style="overflow-x: scroll;">
                                <div class="chip main mr-5 mb-5 fx-row align-items-center justify-content-start"
                                    *ngFor="let nice of niceClassification; let index = index" style="flex-shrink: 0">
                                    <span style="flex-shrink: 0">{{'NICE_CLASSES.CLASS_NUMBER' |
                                        translate}}{{nice}}</span>
                                    <mat-icon inline inset class="ml-5 clickable fx-flex"
                                        fontSet="material-icons-outlined" (click)="removeNice(index)"
                                        *ngIf="editTmNice">cancel</mat-icon>
                                </div>
                            </div>
                        </div>
                    </div>

                    <mat-divider></mat-divider>
                </div>
                <div class="options-container pv-16" *ngIf="multiple" [scrollWindow]="false" [class.search]="search"
                    [class.large]="(trademarks && trademarks.length > 0) || (niceClassification && niceClassification.length > 0)"
                    infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()">
                    <div class="fx-column" *ngIf="selectedToDisplay().length > 0">
                        <div class="fx-row align-items-center justify-content-start clickable option-multiple actionable"
                            *ngFor="let productService of selectedToDisplay(); let index = index"
                            (click)="removeFromPreselection(productService)">
                            <mat-checkbox color="primary" [checked]="productService.selected">
                            </mat-checkbox>
                            <div class="fx-column align-items-start justify-content-start ml-5 option-label"
                                *ngIf="productService.label">
                                <div class="fx-row align-items-center justify-content-start">

                                    <span class="text option-label fx-row align-items-center justify-content-start">
                                        <mat-icon inline inset class="mr-5" fontSet="material-icons-outlined"
                                            [matTooltipClass]="{'uzai-tooltip':true}"
                                            [matTooltip]="productService.label">info</mat-icon>{{truncate(productService.label)}}</span>
                                </div>

                                <span class="small light">{{productService?.trademark?.name ||
                                    productService?.trademark?.identifierNumber}}
                                    ({{productService?.trademark?.countryOfDesignation}}) -
                                    {{'NICE_CLASSES.CLASS_NUMBER' |
                                    translate}}{{productService?.classNumber}}</span>
                            </div>
                        </div>
                        <mat-divider></mat-divider>
                    </div>
                    <div class="fx-column">
                        <div class="fx-row align-items-center justify-content-start clickable option-multiple"
                            *ngFor="let productService of filtered(); let index = index"
                            (click)="productService.disabled ? null : select(productService)"
                            [class.disabled]="productService.disabled" [class.actionable]="search">
                            <mat-checkbox color="primary" [checked]="productService.selected">
                            </mat-checkbox>
                            <div class="fx-column align-items-start justify-content-start ml-5"
                                *ngIf="productService.label">
                                <span class="text option-label fx-row align-items-center justify-content-start">
                                    <mat-icon inline inset class="mr-5" fontSet="material-icons-outlined"
                                        [matTooltipClass]="{'uzai-tooltip':true}"
                                        [matTooltip]="productService.label">info</mat-icon>{{truncate(productService.label)}}</span>
                                <span class="small light">{{productService?.trademark?.name ||
                                    productService?.trademark?.identifierNumber}}
                                    ({{productService?.trademark?.countryOfDesignation}}) -
                                    {{'NICE_CLASSES.CLASS_NUMBER' |
                                    translate}}{{productService?.classNumber}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="ph-16" *ngIf="filtered().length === 0">
                        <span class="light text">{{'PAGINATOR.GENERIC_SEARCH_NO_RESULTS' | translate}}</span>
                    </div>
                </div>
                <div class="options-container" *ngIf="!multiple" [scrollWindow]="false" [class.search]="search"
                    [class.large]="(trademarks && trademarks.length > 0) || (niceClassification && niceClassification.length > 0)"
                    infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()">
                    <div class="fx-column">
                        <div class="fx-row align-items-center justify-content-start clickable option actionable p-8"
                            *ngFor="let productService of filtered(); let index = index"
                            [class.selected]="productService.selected"
                            (click)="productService.disabled ? null : select(productService)"
                            [class.disabled]="productService.disabled">
                            <div class="fx-column align-items-start justify-content-start ml-5">
                                <span class="text option-label fx-row align-items-center justify-content-start">
                                    <mat-icon inline inset class="mr-5" fontSet="material-icons-outlined"
                                        [matTooltipClass]="{'uzai-tooltip':true}"
                                        [matTooltip]="productService.label">info</mat-icon>{{truncate(productService.label)}}</span>
                                <span class="small light">{{productService?.trademark?.name ||
                                    productService?.trademark?.identifierNumber}}
                                    ({{productService?.trademark?.countryOfDesignation}}) -
                                    {{'NICE_CLASSES.CLASS_NUMBER' |
                                    translate}}{{productService?.classNumber}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="p-16" *ngIf="filtered().length === 0">
                        <span class="light text">{{'PAGINATOR.GENERIC_SEARCH_NO_RESULTS' | translate}}</span>
                    </div>
                </div>
            </div>
            <app-progress-bar [mode]="'indeterminate'" [loading]="loading"></app-progress-bar>
        </mat-card>
    </ng-template>
</div>